// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/swipe-item/index.css
// module id = 211
// module chunks = 32